import axios from 'axios'
import router from '@/router'
import { baseURL } from './constants'
import { useAdminStore } from '@/stores/AdminStore'
import { Snackbar } from '@varlet/ui'

function isFormDataPayload(payload) {
  return typeof FormData !== 'undefined' && payload instanceof FormData
}

// 创建管理端 axios 实例
export const adminApi = axios.create({
  baseURL: `${baseURL}/admin`,
  timeout: 30000
  // 不在默认headers中设置Content-Type，避免GET请求出现415错误
})

// 请求拦截器
adminApi.interceptors.request.use(
  (config) => {
    const adminStore = useAdminStore()
    if (adminStore.token) {
      config.headers.Authorization = `Bearer ${adminStore.token}`
      console.log('[adminApi] 添加Authorization头:', {
        url: config.url,
        hasToken: !!adminStore.token,
        tokenLength: adminStore.token?.length
      })
    } else {
      console.warn('[adminApi] 未找到token:', {
        url: config.url,
        token: adminStore.token,
        adminInfo: adminStore.adminInfo
      })
    }
    // 只为POST/PUT/PATCH/DELETE请求设置Content-Type
    const method = config.method?.toLowerCase()
    const shouldSetJsonContentType = !isFormDataPayload(config.data)
      && (method === 'post' || method === 'put' || method === 'patch' || method === 'delete')
    if (shouldSetJsonContentType) {
      config.headers['Content-Type'] = 'application/json'
    } else if (isFormDataPayload(config.data)) {
      // 上传文件时交给浏览器自动补充 multipart boundary
      delete config.headers['Content-Type']
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 响应拦截器
adminApi.interceptors.response.use(
  (response) => {
    const data = response.data
    // 如果后端返回的格式是 { suc, msg, data }
    if (data.suc === false) {
      Snackbar.error(data.msg || '请求失败')
      return Promise.reject(new Error(data.msg || '请求失败'))
    }
    return data
  },
  (error) => {
    if (error.response) {
      const status = error.response.status
      const data = error.response.data

      if (status === 401) {
        // 未授权，跳转到登录页
        console.warn('[adminApi] 401错误:', {
          url: error.config?.url,
          response: data,
          currentToken: useAdminStore().token ? '存在' : '不存在'
        })
        const adminStore = useAdminStore()
        adminStore.logout()
        router.push({ name: 'admin-login' })
        Snackbar.error(data?.msg || '登录已过期，请重新登录')
      } else if (data?.msg) {
        Snackbar.error(data.msg)
      } else if (status === 403) {
        Snackbar.error('权限不足')
      } else if (status === 404) {
        Snackbar.error('请求的资源不存在')
      } else if (status >= 500) {
        Snackbar.error('服务器错误，请稍后重试')
      }
    } else if (error.request) {
      Snackbar.error('网络连接失败，请检查网络设置')
    } else {
      Snackbar.error(error.message || '请求失败，请稍后重试')
    }

    return Promise.reject(error)
  }
)

export default adminApi
